<template>
  <d-modal
    :modal="modal"
    :title="$t('logs.details.page-heading')"
    @closeModal="handleCloseModal"
    :hideSubmitButton="true"
  >
    <template slot="body">
      <v-row>
        <v-col cols="12" class="mb-3">
          <BaseLog :getLogs="getLogs" :hideDetails="true"></BaseLog>
        </v-col>
      </v-row>
    </template>
  </d-modal>
</template>
    
    <script>
import { getUserApisLogs } from "@/services/user";
import BaseLog from "@/components/BaseLog/BaseLog.vue";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    item: Object,
  },
  components: { BaseLog },
  computed: {
    userId() {
      return this.$route.params.id;
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit("closeModal");
    },
    getLogs() {
      return getUserApisLogs({ userId: this.userId, apiId: this.item.id });
    },
  },
};
</script>
    